import React from 'react';
import Link, { LinkProps } from 'next/link';

type PropsType = {
  isNotLink?: boolean;
  children: React.ReactNode;
} & LinkProps &
  Omit<React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>, 'children' | 'ref'>;

export const LinkWrapper: React.FC<PropsType> = ({ children, isNotLink, ...props }) =>
  isNotLink ? children : <Link {...props}>{children}</Link>;
